export enum ListType {
  ANSWERED = 'answered',
  ACTIVE = 'active',
  PRIORITY = 'priority'
}

export enum QuestionAction {
  PRIORITY_CHANGE = 'PRIORITY_CHANGE',
  ANSWERED_CHANGE = 'ANSWERED_CHANGE'
}

export enum QuestionsTabs {
  Active = 'active',
  Answered = 'answered'
}

export enum QuestionLoadingState {
  IDLE = 'Idle',
  LOADING = 'Loading',
  SUCCESS = 'Success',
  ERROR = 'Error'
}